import styled, { css } from 'styled-components';
import { smallScreenListWidth, listWidth, collapsedListWidth } from '../list/styled';

interface ProjectAdminDetailContainerStyledProps {
  isListCollapsed?: boolean;
}

export const ProjectAdminDetailContainerStyled = styled.div<ProjectAdminDetailContainerStyledProps>`
  transition-duration: 160ms;
  transition-timing-function: ease-in;
  transition-property: left;
  height: 100vh;
  position: absolute;
  left: ${listWidth};
  width: calc(100% - ${listWidth});
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
    width: calc(100% - ${smallScreenListWidth});
  }
  ${({ isListCollapsed }) =>
    isListCollapsed &&
    css`
      left: ${collapsedListWidth} !important;
      width: calc(100% - ${collapsedListWidth}) !important;
      box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
    `}
`;
